import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
  IAiPromptsServices,
  IGetPromptUsersRequest,
  IGetPromptUsersResponse,
  IUserRequest,
  IUsersSearchRequest,
  IUsersSearchResponse,
} from './types';
import { IModelServersResponse } from 'redux/reducers/ai-prompts/types';

export const aiPromptsServices: IAiPromptsServices = {
  getModelServers: (): Promise<IModelServersResponse> =>
    http.get(endpoint.ai.GET_MODEL_SERVERS).then((response) => response.data),

  getPromptUsers: (params?: IGetPromptUsersRequest): Promise<IGetPromptUsersResponse> =>
    http.get(endpoint.ai.GET_PROMPT_USERS, { params }).then((response) => response.data),

  addPromptUser: (payload: IUserRequest): Promise<void> =>
    http.post(endpoint.ai.ADD_PROMPT_USER, payload).then((response) => response.data),

  updatePromptUser: (id: string, payload: IUserRequest): Promise<void> =>
    http.put(endpoint.ai.UPDATE_PROMPT_USER(id), payload).then((response) => response.data),

  deletePromptUser: (id: string): Promise<void> =>
    http.delete(endpoint.ai.DELETE_PROMPT_USER(id)).then((response) => response.data),

  searchUsers: (params: IUsersSearchRequest): Promise<IUsersSearchResponse> =>
    http.get(endpoint.ai.SEARCH_USERS, { params }).then((response) => response.data),
};
